var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 11.9993L15.8333 9.49935M15.8333 9.49935L18.3333 11.9993M15.8333 9.49935V14.4993M18.3333 5.33268H1.66663M18.3333 6.99935V3.83268C18.3333 2.89926 18.3333 2.43255 18.1516 2.07603C17.9918 1.76243 17.7369 1.50746 17.4233 1.34767C17.0668 1.16602 16.6 1.16602 15.6666 1.16602H4.33329C3.39987 1.16602 2.93316 1.16602 2.57664 1.34767C2.26304 1.50746 2.00807 1.76243 1.84828 2.07603C1.66663 2.43255 1.66663 2.89926 1.66663 3.83268V10.166C1.66663 11.0994 1.66663 11.5661 1.84828 11.9227C2.00807 12.2363 2.26304 12.4912 2.57664 12.651C2.93316 12.8327 3.39987 12.8327 4.33329 12.8327H9.99996",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.af8bc7c284f566cd5f53d97ea653091b.svg";
export { ForwardRef as ReactComponent };